import { SecondarySquareButton } from '@entur/button';
import { DownwardIcon, UpwardIcon } from '@entur/icons';
import { Tooltip } from '@entur/tooltip';
import { useHotkeys } from 'react-hotkeys-hook';
import { useSearchNavigation } from 'hooks/context/useSearchNavigation';
import styles from './styles.module.scss';

interface NextAndBackButtonsProps {
  id: string | undefined;
}

const PREVIOUS_LABEL = 'Forrige søkeresultat';
const NEXT_LABEL = 'Neste søkeresultat';

const NextAndBackButtons = ({ id }: NextAndBackButtonsProps) => {
  const { hasPrev, hasNext, goPrev, goNext } = useSearchNavigation(id);

  // keyup and active in form fields, like the window listener this replaced
  const hotkeyOptions = { keyup: true, keydown: false, enableOnFormTags: true, enableOnContentEditable: true };
  useHotkeys('alt+up', goPrev, { ...hotkeyOptions, enabled: hasPrev }, [goPrev]);
  useHotkeys('alt+down', goNext, { ...hotkeyOptions, enabled: hasNext }, [goNext]);

  if (!hasNext && !hasPrev) {
    return null;
  }

  return (
    <div className={styles.buttonGrid}>
      <Tooltip content={PREVIOUS_LABEL} placement="bottom">
        <SecondarySquareButton onClick={goPrev} disabled={!hasPrev} aria-label={PREVIOUS_LABEL}>
          <UpwardIcon />
        </SecondarySquareButton>
      </Tooltip>
      <Tooltip content={NEXT_LABEL} placement="bottom">
        <SecondarySquareButton onClick={goNext} disabled={!hasNext} aria-label={NEXT_LABEL}>
          <DownwardIcon />
        </SecondarySquareButton>
      </Tooltip>
    </div>
  );
};

export default NextAndBackButtons;
